const parameters = {
  id: "parameters",
  label: "Parameters",
  endpoint: "parameters",
  columnConfig: [
    {
      field: "name",
      headerName: "Parameter",
      width: 250,
      description: "Parameter",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default parameters;
